import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview-button',
  templateUrl: './preview-button.component.html',
  styleUrls: ['./preview-button.component.scss']
})
export class PreviewButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
